import React, { memo } from 'react'
import tw from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import { customerProfileDocumentsTitles } from 'src/constants/customer/constants'
import { CustomerProfileDocumentsStatus } from 'src/constants/customer/enums'
import type { Customer } from 'src/interfaces/customer'
import { shouldShowMasterContractorValue } from 'src/utils/customerList'
import { semanticColors } from 'src/constants/semanticTokens'

interface Props {
  customer: Customer
}

const COMPLETE_STYLES = {
  chip: { backgroundColor: semanticColors.feedback.successBg },
  text: { color: semanticColors.feedback.successFg },
}

const PENDING_STYLES = {
  chip: { backgroundColor: semanticColors.feedback.warningBg },
  text: { color: semanticColors.feedback.warningFg },
}

const FAILED_STYLES = {
  chip: { backgroundColor: semanticColors.feedback.errorBgMd },
  text: { color: semanticColors.feedback.errorFg },
}

const resolveStyles = (status: CustomerProfileDocumentsStatus) => {
  if (status === CustomerProfileDocumentsStatus.Completed) {
    return COMPLETE_STYLES
  }

  if (
    status === CustomerProfileDocumentsStatus.Failed ||
    status === CustomerProfileDocumentsStatus.Expired
  ) {
    return FAILED_STYLES
  }

  return PENDING_STYLES
}

/** Retool only surfaced this for master contractors — keep that behaviour. */
const CustomerProfileDocumentsChipComponent = ({ customer }: Props) => {
  if (!shouldShowMasterContractorValue(customer)) {
    return <span css={tw`text-shades-400`}>—</span>
  }

  const styles = resolveStyles(customer.profileDocumentsStatus)

  return (
    <Chip
      text={customerProfileDocumentsTitles[customer.profileDocumentsStatus]}
      className={styles.chip}
      textClassName={styles.text}
    />
  )
}

export const CustomerProfileDocumentsChip = memo(CustomerProfileDocumentsChipComponent)
